<template>
    <div>
        <v-container fluid>
            <v-row no-gutters>
                <v-col :cols="6">
                    <h1 class="headline font-weight-light mb-3">
                        Permission
                    </h1>
                </v-col>
                <v-col :cols="6" class="text-right">
                    <!-- <v-btn
                        color="primary"
                        dark
                        small
                        rounded
                        to="/Permission/Manage-Add"
                        ><v-icon small class="mr-1">mdi-plus</v-icon>Add
                        Permissions</v-btn
                    > -->
                </v-col>
            </v-row>
            <v-card class="mt-5">
                <v-row>
                    <v-col cols="12">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th class="text-center">Team</th>
                                        <th class="text-center">Status</th>
                                        <th class="text-center"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(row, index) in datas"
                                        :key="row.team_id"
                                    >
                                        <td class="text-center">
                                            {{ index + 1 }}.
                                        </td>
                                        <td>{{ row.team_name }}</td>
                                        <td class="text-center">
                                            <v-icon
                                                :color="
                                                    row.team_status == 1
                                                        ? 'success'
                                                        : 'red'
                                                "
                                                >{{
                                                    row.team_status == 1
                                                        ? "mdi-checkbox-marked-circle"
                                                        : "mdi-close-circle"
                                                }}</v-icon
                                            >
                                        </td>
                                        <td class="text-center">
                                            <v-btn
                                                color="info"
                                                fab
                                                x-small
                                                :to="
                                                    '/Permission/Manage/' +
                                                        row.team_id
                                                "
                                                ><v-icon x-small
                                                    >mdi-plus</v-icon
                                                >
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/team/`

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.chk_url()
    },
    methods: {
        async chk_url() {
            let send = {
                url: this.$route.path,
            }
            await axios
                .post(
                    `${process.env.VUE_APP_ROOT_API}/api/` + "check-auth",
                    send,
                    this.tk
                )
                .then((response) => {
                    if (response.data.status == "error") {
                        this.$root.$router.push({
                            path: "/404",
                        })
                    } else {
                        this.get_data()
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_data() {
            let { data } = await axios.get(url)
            this.datas = data
        },
    },
    data() {
        return {
            tk: null,
            datas: [],
        }
    },
}
</script>
